module.exports = __webpack_public_path__ + "static/media/11.09af0c69.png";